import { render, staticRenderFns } from "./ServiceTypeInfoBoxes.vue?vue&type=template&id=92080afc"
import script from "./ServiceTypeInfoBoxes.vue?vue&type=script&lang=js"
export * from "./ServiceTypeInfoBoxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports